<template>
  <div>
    <lvHeader></lvHeader>
    <!-- 交易中心 -->
    <div class="tradingCenter w">
      <div class="tradingCenter_title navOne">
        <div class="trade">
          <img src="../assets/images/20200303_jy.png" alt="">
          交易
        </div>
        <!-- 导航 -->
        <el-menu :default-active="activePath" class="el-menu-demo" mode="horizontal" @select="handleSelect">
          <el-menu-item :index="'/' + item.routerName" :key="item.id" v-for="(item) in navList" @click="saveNavState('/' + item.routerName)">{{item.name}}</el-menu-item>
        </el-menu>
      </div>
      <div class="tradingCenter_con">
        <router-view></router-view>
      </div>
    </div>
    <!-- 返回旧部 -->
    <!-- <a href="https://trade.myfund.com/kfit/page/frame/frame.htm" target="_block" class="rebackold">
      <img src="../assets/images/rebackold.png" alt="">
    </a> -->
    <!-- 意见反馈 -->
    <div class="feedback" @click="$router.push({name:'feedback'})">
      <img src="../assets/images/feedback.png" alt="">
      <p>意见反馈</p>
    </div>
    <lvFooter></lvFooter>

  </div>
</template>

<script>
import lvHeader from '@/components/lv-header/lv-header.vue';
import lvFooter from '@/components/lv-footer/lv-footer.vue';
export default {
  name: "index",
  components: {
    lvHeader,
    lvFooter
  },
  data () {
    return {
      navList: [
        {
          name: '我的资产',
          routerName: 'myAssets',
          isShow: true,
          isActive: true,
        },
        {
          name: '我的诊断',
          routerName: 'myDiagnosis',
        },
        {
          name: '我的自选',
          routerName: 'myChoice',
        },
        // {  //todo 2024.8.30  应翟文老师需求该模块暂时没人维护，与整体功能相比需求较小，所以注释，后期有需要可以恢复
        //   name: '我的顾问',
        //   routerName: 'myAdviser',
        // },
        {
          name: '优惠券',
          routerName: 'coupon',
        },
        {
          name: '点财通会员',
          routerName: 'member',
        },
        {
          name: '账户管理',
          routerName: 'accountManagement',
        },
        {
          name: '消息中心',
          routerName: 'messageCenter',
        },
        // {
        //   name: '意见反馈',
        //   routerName: 'feedback',
        // },
      ],
      activePath: '/myAssets'
    }
  },
  created () {
    if (this.$route.fullPath != this.$commonJs.getCookie('acticePath')) {
      this.activePath = this.$route.fullPath
    } else {
      this.activePath = this.$commonJs.getCookie('acticePath')
    }

  },

  methods: {
    saveNavState (activePath) {
      this.$commonJs.setCookie('acticePath', activePath, 3);
      this.activePath = activePath
      this.$router.push(activePath)
    },
    handleSelect () {

    }
  },
  watch: {
    // 监听路由变化
    $route: {
      handler: function (to) {
        this.activePath = to.fullPath
        this.$commonJs.setCookie('acticePath', to.fullPath, 3);
      }
    }
  },


}
 </script>

<style lang="less">
// 导航
.navOne {
  background: #e9e9e9;
  .el-menu--horizontal > .el-menu-item {
    width: 130.5px;
    height: 100%;
    line-height: 45px;
    text-align: center;
    font-size: 18px;
    color: #2a2a2a;
  }
  .el-menu.el-menu--horizontal {
    border: none;
  }
  .el-menu--horizontal > .el-menu-item.is-active {
    border: none;
    background: #246ead;
    color: #fff;
    font-size: 18px;
    font-weight: bold;
  }
  .el-menu--horizontal > .el-menu-item:not(.is-disabled):focus {
    background: #246ead;
    color: #fff;
    font-size: 18px;
    font-weight: bold;
  }
}
// 交易
.tradingCenter {
  margin-top: 8px;
  &_title {
    position: relative;
    height: 45px;
    background: #e9e9e9;
    // border-bottom: 1px solid #c8c8c8;
    .trade {
      width: 150px;
      height: 100%;
      line-height: 45px;
      text-align: center;
      font-size: 18px;
      color: #fff;
      font-weight: bold;
      background: #246ead;
      border-right: 5px solid #fff;
    }
    .el-menu {
      position: absolute;
      left: 155px;
      top: 0;
      height: 45px;
      background: #e9e9e9;
    }
  }
}
.rebackold {
  position: fixed;
  left: 0;
  top: 175px;
  cursor: pointer;
  z-index: 9999999999;
}
.feedback {
  width: 60px;
  height: 60px;
  text-align: center;
  position: fixed;
  right: 50%;
  top: 500px;
  margin-right: -692px;
  cursor: pointer;
  box-shadow: #91b6d6 0px 0px 9px;
  font-size: 12px;
  color: @color;
  border-radius: 5px;
  user-select: none;
  background: @wColor;
  img {
    margin: 10px auto 5px;
  }
}
</style>
